import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import GenericPromises from "../../../api/GenericPromises";
import { Button } from "@mui/material";
import { Header } from "../../../components/Header";
import { usePermissions } from "../../../hooks/usePermissions";
import { UpdateBankAccounts } from "./update";
import { BankAccount } from "../../../interfaces/Commons/bankAccounts";
import { Menuitem } from "../../../interfaces/Security/menu";
import { Spinner } from "../../../components/Commons/Spinner/Spinner";
import { GenericDialog } from "../../../components/Dialogs/Dialog";
import useSnackBar from "../../../components/Commons/SnackBar/useSnackBar";
import { ButtonStyled } from "../../../theme/buttons";

export const ViewBankAccounts = () => {
  const [t] = useTranslation("global");
  const location = useLocation();
  const navigate = useNavigate();
  const [bankAccountsLocal, setBankAccountsLocal] = useState<BankAccount>();
  const [openDialog, setOpenDialog] = useState(false);
  const [dataloaded, setDataLoaded] = useState(false);
  const { GenericGetResource, GenericDeleteResource } = GenericPromises();
  const { showSnackBar, SnackbarComponent } = useSnackBar();
  const [resourceScreen, setResourceScreen] = useState<Menuitem>();
  const { GetResourceByUrl } = usePermissions();


  const onDelete = () => {
    GenericDeleteResource(`/bankaccounts/${bankAccountsLocal?.bank_account_id}`)
      .then(() => {
        setOpenDialog(false);
        navigate("/bankaccounts", { state: { method: "delete" }, replace: true });
      })
      .catch((error) => {
        showSnackBar(error.message, 'error');
        setOpenDialog(false);
      })
  }



  useEffect(() => {
    if (location.state === null) return navigate("/bankaccounts", { state: {}, replace: true });
    GenericGetResource(`/bankaccounts/${location.state.row.bank_account_id}`)
      .then(
        (response) => {
          setBankAccountsLocal(response.data);

          GetResourceByUrl(`/bankaccounts`)
            .then((response1) => {
              setResourceScreen((prev) => response1);
              setDataLoaded(true);
            })
            .catch((error) => {
              showSnackBar(error.message, 'error');
            });
        }
      ).catch((error) => {
        showSnackBar(error.message, 'error');
      });
  }, []);

  return (
    <>
      {!dataloaded && <Spinner />}
      {dataloaded &&
        <>
          <Header title={t("bankaccounts.title-view")} />
          {resourceScreen?.read &&
            <>
              <div className='d-flex flex-row-reverse m-1'>
                {resourceScreen?.delete === true &&
                  <ButtonStyled variant="contained" className="my-1" onClick={() => setOpenDialog(true)}>{t("generic.buttons.delete")}</ButtonStyled>
                }
                <Button variant="outlined" onClick={() => { navigate("/bankaccounts", { replace: true }) }}>{t("generic.buttons.goback")}</Button>
              </div>
              <div>
                <UpdateBankAccounts bankAccountPayload={bankAccountsLocal} isEdit={resourceScreen?.update} />
              </div>
            </>
          }
        </>
      }
      <GenericDialog
        title={t("generic.dialog.delete")}
        content={t("bankaccounts.dialog.delete")}
        open={openDialog}
        setOpen={setOpenDialog}
        onAcept={onDelete}
      />
      <SnackbarComponent />
    </>
  )
}
